
import { Component, Vue } from 'vue-property-decorator'
import { Page } from '@/types/common'
import { PageType } from '@/types/messageType'
import { MessageType } from '@/utils/enum'

@Component({
  name: 'Message'
})
export default class extends Vue {
  private tableData = {
    loading: false,
    tr: [
      {
        label: '消息分类',
        prop: 'templateTypeName',
        minWidth: '120',
        showOverflowTooltip: true
      },
      {
        label: '类型编号',
        prop: 'templateTypeCode',
        minWidth: '100',
        showOverflowTooltip: true
      },
      {
        label: '状态',
        prop: 'templateTypeState',
        minWidth: '100'
      }
    ],
    data: [{}]
  }

  private messageType = MessageType

  private total = 0
  private page = 1
  private size = 10
  created () {
    this.getData()
  }

  getData () {
    this.tableData.loading = true
    this.$axios.get<Page<PageType>>(this.$apis.messageType.templateTypePage, {
      page: this.page,
      size: this.size
    })
      .then((res) => {
        this.tableData.data = res.list || []
        this.total = res.total || 0
        this.tableData.loading = false
      })
      .catch((err) => {
        this.tableData.loading = false
        console.log(err)
      })
  }

  onDisable (id: string) {
    this.$axios.post(this.$apis.messageType.templateTypeDisable, {
      id: id
    })
      .then(() => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.getData()
      })
      .catch((err) => {
        this.$message.error(err)
      })
  }
}
